import React, { Fragment } from 'react'
import EXTENSION_PREVIEW_IMAGE from 'images/EXTENSION_PREVIEW_IMAGE.svg'

import chromeNotification from './chrome-notif.png'
import arrowSrc from './arrow.svg'

import './style.css'

export default ({ isCalendarSeat }) => (
  <Fragment>
    {isCalendarSeat ? (
      <div className='new-extension-preview'>
        <div className='new-extension-preview-message'>
          <p>
            This is how you&rsquo;ll be notified when a target account is on your site!
          </p>
          <img className="new-extension-arrow" src={arrowSrc} alt=''/>
        </div>
        <div className='new-extension-preview-container'>
          <img className='new-extension-preview-content' src={chromeNotification} alt=''/>
        </div>
      </div>
    ) : (
      <Fragment>
        <img src={EXTENSION_PREVIEW_IMAGE} alt="extension-preview" style={{ height: 525 }} />
      </Fragment> 
    )}
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/layouts/ExtensionPreview/index.js